import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { getEmailAutomationSwitches, saveEmailAutomationSwitches } from "@/lib/api";

// Master + per-type switches for AUTOMATED emails. Manual sends (buttons you click) are never blocked here.
export default function EmailAutomationSwitches() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { getEmailAutomationSwitches().then(r => setCfg(r.data)).catch(() => toast.error("Couldn't load email switches")); }, []);
  const save = async (next) => {
    const prev = cfg;
    setCfg(next);
    try { const { data } = await saveEmailAutomationSwitches({ master: next.master, types: next.types }); setCfg(data); }
    catch { setCfg(prev); toast.error("Couldn't save email switch"); }
  };
  if (!cfg) return null;
  return (
    <div className="rounded-lg border border-slate-200" data-testid="email-automation-switches">
      <div className="flex items-center gap-3 px-3 py-2.5 border-b border-slate-200">
        <div className="flex-1">
          <div className="text-sm font-semibold text-slate-800">Automated emails</div>
          <div className="text-xs text-slate-500">Emails the app sends on its own. Buttons you click (send, remind, resend) always work.</div>
        </div>
        <span className={`text-xs font-semibold ${cfg.master ? "text-emerald-600" : "text-slate-400"}`}>{cfg.master ? "On" : "Off"}</span>
        <Switch checked={cfg.master} onCheckedChange={(v) => save({ ...cfg, master: v })} data-testid="email-auto-master" />
      </div>
      <div className={`divide-y divide-slate-100 ${cfg.master ? "" : "opacity-50"}`}>
        {cfg.catalog.map(t => (
          <div key={t.key} className="flex items-center gap-3 px-3 py-2">
            <div className="flex-1 min-w-0">
              <div className="text-xs font-medium text-slate-700">{t.label}</div>
              <div className="text-[11px] text-slate-400 truncate">{t.desc}</div>
            </div>
            <Switch checked={!!cfg.types[t.key]} disabled={!cfg.master} onCheckedChange={(v) => save({ ...cfg, types: { ...cfg.types, [t.key]: v } })} data-testid={`email-auto-${t.key}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
